module.exports = __webpack_public_path__ + "static/ESP-e14d9aef54ec441586c645b19f427f18.png";